import axios from "@helpers/axios/private.axios";

/**
 * Positions that just left the open list, completed with their records from the
 * history: the final PnL, the close price and the trigger that fired.
 * The open snapshot is kept for anything the history doesn't have yet.
 *
 * @param {object[]} positions last open snapshots of the closed positions
 * @returns {Promise<object[]>}
 */
export const withClosedDetails = async (positions) => {
  try {
    const resp = await axios.get("/futures/positions/history", {
      params: { ids: positions.map((position) => position.id) },
    });
    const history = resp.data?.data || [];

    return positions.map((position) => ({
      ...position,
      ...history.find((record) => record.id === position.id),
    }));
  } catch (error) {
    return positions;
  }
};
